import React, { useState, useEffect } from "react";
import { AllBudgetReport } from "./AllBudgetReport";
import { Select } from "antd";
import { ReportChart } from "./ReportChart";
import downloadIcon from "../../../assets/images/budget/download.png";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const { Option } = Select;
export const AllReportsMain = () => {
  const history = useHistory();
  const budgetReport = useSelector(
    (state) => state.rootReducer.loginUser.budgetReportData
  );
  console.log("budgetReport inall", budgetReport);
  const tags = ["Spreadsheet", "Chart"];
  const [view, setView] = useState("Spreadsheet");
  const handleView = (tag) => {
    setView(tag);
  };
  useEffect(() => {
    if (budgetReport === undefined || budgetReport === null) {
      history.push("/reports/budgetDetails");
    }
  }, []);
  // function exportToExcel(data, fileName) {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Sheet 1");
  //   const boldStringRow = worksheet.addRow(["Budget Detail Report 2024"]);
  //   boldStringRow.font = { bold: true };
  //   worksheet.addRow([]);

  //   Object.keys(data).forEach((sectionKey) => {
  //     const headerRow = worksheet.addRow([sectionKey]);
  //     headerRow.font = { bold: true };
  //     const sectionData = data[sectionKey];
  //     const tableHeader = worksheet.addRow(Object.keys(sectionData[0]));

  //     tableHeader.eachCell((cell, colNumber) => {
  //       cell.border = {
  //         top: { style: "thin" },
  //         left: { style: "thin" },
  //         bottom: { style: "thin" },
  //         right: { style: "thin" },
  //       };

  //       cell.fill = {
  //         type: "pattern",
  //         pattern: "solid",
  //         fgColor: { argb: "FFFFFF00" },
  //       };

  //       cell.font = { bold: true };
  //       worksheet.getColumn(colNumber).width = 25;
  //     });

  //     sectionData.forEach((item) => {
  //       const rowData = Object.values(item);
  //       const row = worksheet.addRow(rowData);

  //       row.eachCell((cell, colNumber) => {
  //         cell.border = {
  //           top: { style: "thin" },
  //           left: { style: "thin" },
  //           bottom: { style: "thin" },
  //           right: { style: "thin" },
  //         };

  //         if (colNumber >= 2 && colNumber <= 4) {
  //           cell.alignment = { horizontal: "center" };
  //         }
  //       });
  //     });
  //     worksheet.addRow([]);
  //   });

  //   workbook.xlsx.writeBuffer().then((buffer) => {
  //     const blob = new Blob([buffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     saveAs(blob, fileName);
  //   });
  // }

  function exportToExcel(data, fileName) {
    const workbook = new ExcelJS.Workbook();
    // const worksheet = workbook.addWorksheet("Sheet 1");

    // this is for hiding gridline from worksheet
    const worksheet = workbook.addWorksheet("Sheet 1", {
      properties: { tabColor: { argb: "FF00FF00" } },
      views: [{ state: "frozen", showGridLines: false }],
    });
    const boldStringRow = worksheet.addRow(["Budget Detail Report"]);
    boldStringRow.font = { bold: true };
    worksheet.addRow([]);

    let startCol = 1; // Starting column for the first table
    const startRow = worksheet.lastRow.number + 1; // Starting row for the first table

    Object.keys(data).forEach((sectionKey, sectionIndex) => {
      const sectionData = data[sectionKey];

      // Add section header
      worksheet.getCell(startRow, startCol).value = sectionKey;
      worksheet.getCell(startRow, startCol).font = { bold: true };

      // Add table headers
      const tableHeaderRow = startRow + 1;
      Object.keys(sectionData[0]).forEach((header, index) => {
        const cell = worksheet.getCell(tableHeaderRow, startCol + index);
        cell.value = header;
        cell.font = { bold: true, name: "Aptos Narrow" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "92d050" },
        };
        worksheet.getColumn(startCol + index).width = 25;
      });

      // Add table data
      sectionData.forEach((item, itemIndex) => {
        const rowData = Object.values(item);
        const row = worksheet.getRow(tableHeaderRow + 1 + itemIndex);
        rowData.forEach((data, colIndex) => {
          const cell = row.getCell(startCol + colIndex);
          cell.value = data;
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (colIndex >= 1 && colIndex <= 3) {
            cell.alignment = { horizontal: "center" };
          }
        });
      });

      // Move to the next column for the next table
      startCol += Object.keys(sectionData[0]).length + 1;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    });
  }

  // const data = {
  //   Category: [
  //     {
  //       categoryFromPlaid: "Shopping",
  //       amount: 500,
  //     },
  //     {
  //       categoryFromPlaid: "Travelling",
  //       amount: 400,
  //     },
  //     {
  //       categoryFromPlaid: "Fast Food",
  //       amount: 900,
  //     },
  //     {
  //       categoryFromPlaid: "Groceries",
  //       amount: 800,
  //     },

  //   ],

  //   January: [
  //     {
  //       date: "January 31, 2024",
  //       itemName: "Amazon",
  //       categoryFromPlaid: "Shopping",
  //       bankName: "Chase",
  //       amount: 500,
  //       accountType: "student",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "Jun 30, 2024",
  //       itemName: "Uber",
  //       categoryFromPlaid: "Travelling",
  //       bankName: "Chase",
  //       amount: 400,
  //       accountType: "savings",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "April 30, 2024",
  //       itemName: "Apple",
  //       categoryFromPlaid: "Fast Food",
  //       bankName: "Chase",
  //       amount: 900,
  //       accountType: "checking",
  //       typeOfTransaction: "Check",
  //     },
  //     {
  //       date: "Aug 31, 2024",
  //       itemName: "Amazon",
  //       categoryFromPlaid: "Groceries",
  //       bankName: "Chase",
  //       amount: 800,
  //       accountType: "mortgage",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "April 08, 2024",
  //       itemName: "Amazon",
  //       categoryFromPlaid: "Groceries",
  //       bankName: "Chase",
  //       amount: 1200,
  //       accountType: "credit card",
  //       typeOfTransaction: "Check",
  //     },
  //   ],

  //   February: [
  //     {
  //       date: "January 31, 2024",
  //       itemName: "Amazon",
  //       categoryFromPlaid: "Shopping",
  //       bankName: "Chase",
  //       amount: 500,
  //       accountType: "student",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "Jun 30, 2024",
  //       itemName: "Uber",
  //       categoryFromPlaid: "Travelling",
  //       bankName: "Chase",
  //       amount: 400,
  //       accountType: "savings",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "April 30, 2024",
  //       itemName: "Apple",
  //       categoryFromPlaid: "Fast Food",
  //       bankName: "Chase",
  //       amount: 900,
  //       accountType: "checking",
  //       typeOfTransaction: "Check",
  //     },
  //   ],
  //   March: [
  //     {
  //       date: "January 31, 2024",
  //       itemName: "Amazon",
  //       categoryFromPlaid: "Shopping",
  //       bankName: "Chase",
  //       amount: 500,
  //       accountType: "student",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "Jun 30, 2024",
  //       itemName: "Uber",
  //       categoryFromPlaid: "Travelling",
  //       bankName: "Chase",
  //       amount: 400,
  //       accountType: "savings",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "April 30, 2024",
  //       itemName: "Apple",
  //       categoryFromPlaid: "Fast Food",
  //       bankName: "Chase",
  //       amount: 900,
  //       accountType: "checking",
  //       typeOfTransaction: "Check",
  //     },
  //   ],
  //   April: [
  //     {
  //       date: "Jun 30, 2024",
  //       itemName: "Uber",
  //       categoryFromPlaid: "Travelling",
  //       bankName: "Chase",
  //       amount: 400,
  //       accountType: "savings",
  //       typeOfTransaction: "Cash",
  //     },
  //     {
  //       date: "April 30, 2024",
  //       itemName: "Apple",
  //       categoryFromPlaid: "Fast Food",
  //       bankName: "Chase",
  //       amount: 900,
  //       accountType: "checking",
  //       typeOfTransaction: "Check",
  //     },
  //   ],
  // };
  const data = {
    Category: [
      { Category: "Transfer", Amount: "$30233.12" },
      { Category: "Shops", Amount: "$3500.00" },
      { Category: "Food and Drink", Amount: "$7528.65" },
      { Category: "Payment", Amount: "$14774.50" },
      { Category: "Travel", Amount: "$1097.38" },
      { Category: "Recreation", Amount: "$471.00" },
      { Category: "Bank Fees", Amount: "$5850.00" },
      { Category: "Income", Amount: "$52.00" },
      { Category: "Community", Amount: "$55.55" },
    ],
    "May 2024": [
      {
        "Item Name": "ACH Electronic CreditGUSTO PAY 123456",
        Amount: "$35100.00",
      },
      { "Item Name": "Madison Bicycle Shop", Amount: "$3500.00" },
      { "Item Name": "KFC", Amount: "$3500.00" },
      { "Item Name": "AUTOMATIC PAYMENT - THANK", Amount: "$14549.50" },
      { "Item Name": "Tectra Inc", Amount: "$3500.00" },
      { "Item Name": "United Airlines", Amount: "$500.00" },
      { "Item Name": "Touchstone Climbing", Amount: "$471.00" },
      { "Item Name": "Uber 072515 SF**POOL**", Amount: "$37.98" },
      { "Item Name": "SparkFun", Amount: "$447.00" },
      { "Item Name": "Starbucks", Amount: "$21.65" },
      { "Item Name": "McDonald's", Amount: "$60.00" },
      { "Item Name": "Uber 063015 SF**POOL**", Amount: "$27.00" },
      { "Item Name": "INTRST PYMNT", Amount: "$-16.88" },
      { "Item Name": "CREDIT CARD 3333 PAYMENT *//", Amount: "$100.00" },
      { "Item Name": "CD DEPOSIT .INITIAL.", Amount: "$1000.00" },
      { "Item Name": "United Air Lines", Amount: "$500.00" },
      { "Item Name": "Burger King", Amount: "$52.00" },
      { "Item Name": "House", Amount: "$55.55" },
    ],
    "April 2024": [
      { "Item Name": "Uber 063015 SF**POOL**", Amount: "$32.40" },
      { "Item Name": "CREDIT CARD 3333 PAYMENT *//", Amount: "$125.00" },
    ],
  };

  // function for formating data for excel sheet required format for given transactions we have to give it transactions data
  function transformData(data) {
    const result = {
      Category: [],
    };

    // Helper function to format date to month and year
    function getMonth(date) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const d = new Date(date);
      return monthNames[d.getMonth()] + " " + d.getFullYear();
    }

    // Sum amounts by category
    const categoryMap = new Map();
    data.forEach((item) => {
      const category = item.categoryFromPlaid || "Unknown";
      if (categoryMap.has(category)) {
        categoryMap.set(category, categoryMap.get(category) + item.amount);
      } else {
        categoryMap.set(category, item.amount);
      }
    });

    categoryMap.forEach((amount, category) => {
      result.Category.push({ Category: category, Amount: amount.toFixed(2) });
    });

    // Group items by month and sum amounts by itemName and bankName
    data.forEach((item) => {
      const month = getMonth(item.date);
      if (!result[month]) {
        result[month] = [];
      }
      const existingItem = result[month].find(
        (entry) => entry[`Item Name`] === item.itemName
      );
      if (existingItem) {
        existingItem.Amount += item.amount;
      } else {
        result[month].push({
          "Item Name": item.itemName,
          // bankName: item.bankName,
          Amount: item.amount,
        });
      }
    });
    // Format amounts in month groups with dollar sign
    Object.keys(result).forEach((key) => {
      if (key !== "Category") {
        result[key] = result[key].map((item) => ({
          ...item,
          Amount: `${item.Amount.toFixed(2)}`,
        }));
      }
    });
    return result;
  }

  // Example usage
  const transformedData = budgetReport && transformData(budgetReport);
  console.log("transformedData", transformedData);

  return (
    <div className="BudgetReportMain">
      <div className="budgetSection">
        <div className="addTitle">All Budget Details </div>
        <div className="budgetDetails" style={{ gap: "1rem" }}>
          <button
            className="exportButton"
            onClick={() => {
              exportToExcel(
                transformedData && transformedData,
                "budgetReport.xlsx"
              );
              // setCategoryModal(true);
            }}
          >
            {" "}
            Export{" "}
            <img src={downloadIcon} height={22} width={22} alt="icon"></img>
          </button>
          <div className="filterIcons">
            <Select
              showSearch
              style={{ width: 200, outline: "none", border: "none" }}
              placeholder="Select Filter"
              value={view && view}
              onChange={(value, id) => {
                console.log("value", value);
                handleView(value);
              }}
            >
              {tags &&
                tags.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
      {view && view === "Spreadsheet" && <AllBudgetReport />}
      {view && view === "Chart" && <ReportChart />}
    </div>
  );
};
